// FILE: src/services/group.js (FULLY UPDATED)

import axiosServices from "./axios"

export const facebookCallback = async (code) => {
    try {
      const response = await axiosServices.get("/group/get", {
        params: {
          code,
        },
      });
      return response;
    } catch (error) {
      console.error("Error in facebookCallback:", error);
      return error;
    }
};


export const getGroups = async () => {
  try {
      const response = await axiosServices.get(`/group/get`);
      return response.data.groups;
  } catch (error) {
      console.error("Error fetching groups:", error);
      throw new Error("Error fetching groups");
  }
};

export const checkOnboardingStatus = async (groupId) => {
  try {
      // --- THIS IS THE FIX: Pass groupId as a query parameter ---
      const response = await axiosServices.get(`/onboarding/check-status`, {
          params: { groupId }
      });
      return response.data;
  } catch (error) {
      console.error("Error checking onboarding status:", error);
      return { status: 'error', error: 'Could not fetch status from the server.' };
  }
};

export const getOnboardingForGroup = async (groupId) => {
  try {
    const response = await axiosServices.get(`/onboarding/get-onboarding?groupId=${groupId}`);
    // The endpoint returns an array, we want the first (and only) item.
    return response.data?.OnBoarding?.[0] || null;
  } catch (error) {
    console.error("Error fetching onboarding data for group:", error);
    throw error;
  }
};


export const getProfileDetails = async (groupId) => {
  try {
    const response = await axiosServices.get(`/onboarding/get-onboarding?groupId=${groupId}`);
    return response.data;
  } catch (error) {
    console.error("Error in getProfileDetails:", error);
    throw error;
  }
};

export const updateOnboardingData = async (data) => {
  try {
    const response = await axiosServices.patch("/onboarding/add-onboarding2", data);
    return response.data;
  } catch (error) {
    console.error("Error in updateOnboardingData:", error);
    throw error;
  }
};

export const saveWebsite = async (website) => {
  try {
    const response = await axiosServices.patch(
      "/onboarding/add-onboarding2",
      { website },
  
    );
    return response.data;
  } catch (error) {
    console.error("Error in saveWebsite:", error);
    return error;
  }
};

 
  export const getEngagementData = async (filter, sinceSelector, untilSelector,groupName) => {
    try {
    
  
      // Extracting profiles
      const selectedProfiles = filter[0]?.map((elem) => elem.platform_id);
  
      // Convert timestamps to date strings
      const formatDate = (timestamp) => {
        const date = new Date(timestamp * 1000);
        return `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      };
  
      const since = formatDate(sinceSelector[0]);
      const until = formatDate(untilSelector[0]);
  
      const response = await axiosServices.post(
        `/group/group-analytics`,
        {
          groupName: groupName,
          selectedProfiles,
          since,
          until,
        },
      
      );
   
      return response.data.analytics;
    } catch (error) {
      console.error("Error fetching engagement data:", error);
      return error;
    }
  };

export const fetchInstagramProfile = async (insta_id) => {
  try {
    const response = await axiosServices.post('/instagram/profile', { insta_id });
    return response.data;
  } catch (error) {
    console.error('Error fetching Instagram profile:', error);
    throw error;
  }
};
export const fetchfacebookProfile = async (data) => {
  try {
    const response = await axiosServices.post('/facebook/profile_details', {...data,
      groupName:localStorage.getItem('oolook_default_group')});
    return response.data;
  } catch (error) {
    console.error('Error fetching Instagram profile:', error);
    throw error;
  }
};
export const fetchInstagramEngagment = async (data, type) => {
  try {
    const response = await axiosServices.post(`/${type}/get-profile-engagement`,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching Instagram profile:', error);
    throw error;
  }
};

export const fetchDrafts = async (groupName) => {
try {
const response = await axiosServices.get('/group/get-draft/' + groupName);
const queueVisibleStatuses = [
'draft',
'scheduled',
'queued',
'publishing',
'processing',
'failed',
'retrying',
'reconnect_required',
];
return (response.data || []).filter((post) => queueVisibleStatuses.includes(post.status));
} catch (error) {
console.error('Error fetching queue posts:', error);
throw error;
}
};


export const authenticatePinterest = async (code) => {
  try {
   
    const response = await axiosServices.get(`/pinterest/auth/callback`, {
      params: { code, state: "state" },
    
    });
    return response.data.user_id;
  } catch (error) {
    console.error("Pinterest authentication failed:", error);
    return null;
  }
};

export const uploadAssets = async (data) => {
  try {
   
    const response = await axiosServices.patch(
      "/onboarding/add-onboarding3",
      data,
    
    );
    return response;
  } catch (error) {
    console.error("Error in uploadAssets:", error);
    throw error;
  }
};

export const getAssets = async () => {
  try {
  

    const response = await axiosServices.get("/onboarding/get-onboarding/");
    return response;
  } catch (error) {
    console.error("Error in getAssets:", error);
    throw error;
  }
};


export const deleteScheduledPost = async (postId) => {
try {
const response = await axiosServices.delete(`/schedule/delete/${postId}`);
return response.data;
} catch (error) {
console.error('Error deleting scheduled post:', error);
throw error.response?.data || { message: error.message || 'Failed to delete post.' };
}
};

export const updateScheduledPost = async (postId, data) => {
try {
const response = await axiosServices.patch(`/schedule/update/${postId}`, data);
return response.data;
} catch (error) {
console.error('Error updating scheduled post:', error);
if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
const limitError = new Error(error.response.data.message || 'Plan limit reached.');
limitError.isLimitError = true;
limitError.errorType = 'LIMIT_REACHED';
limitError.feature = 'Posts';
throw limitError;
}
throw new Error(error.response?.data?.message || "Failed to update post.");
}
};

export const deleteMultipleScheduledPosts = async (postIds) => {
try {
const response = await axiosServices.post(`/schedule/delete-multiple`, { postIds });
return response.data;
} catch (error) {
console.error('Error deleting multiple posts:', error);
throw error.response?.data || { message: error.message || 'Failed to delete posts.' };
}
};